var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('div',{staticClass:"loading-screen"},[_c('img',{staticClass:"splash-logo",attrs:{"src":require('@/assets/logo.png'),"alt":"Konvenio"}}),_c('div',{staticClass:"spinner"})]):_c('div',[_c('router-view'),_c('CookieBanner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }